import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/team.jpg";
import "../Profiles/Profile.css"; // Using the common Profile CSS
import Breadcrumb from "react-bootstrap/Breadcrumb";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import XIcon from "@mui/icons-material/X"; // Standardized X icon
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import Card3 from "../Images/Profiles/Fred.jpg";
import "../Pages/NewsandEvents.css"; // ← reuse styles for hero and breadcrumb

function FredIsabirye() {
  return (
    <div className="ne-page">
      <SEO
        title="Mr. Fred Isabirye - Field Manager"
        description="Mr. Fred Isabirye is a Field Manager at CIRCODU with a Master's Degree in Intellectual Property and a Bachelor's Degree in Mechanical Engineering."
        keywords="Fred Isabirye, Field Manager, CIRCODU, Master's Degree, Bachelor's Degree, Mechanical Engineering"
        url="/fred-isabirye"
        image={Card3}
        type="profile"
      />

      {/* ── Hero banner ─────────────────────────────── */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="ne-hero__overlay">
          <h4 className="ne-hero__title">Mr. Fred Isabirye</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">The Team</Breadcrumb.Item>
            <Breadcrumb.Item className="text1" href="/the-team/top-management">
              Top Management
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Mr. Fred Isabirye
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Profile section ─────────────────────────── */}
      <section className="profile-section border-bottom">
        <div className="container">
          <div className="profile-card">
            {/* Green banner strip */}
            <div className="profile-card__banner" />

            {/* Photo + name/role */}
            <div className="profile-card__header">
              <div className="profile-card__photo-wrap">
                <img src={Card3} alt="Mr. Fred Isabirye" />
              </div>
              <div className="profile-card__identity">
                <h1 className="profile-card__name">Mr. Fred Isabirye</h1>
                <p className="profile-card__role">Field Manager</p>
                <p className="profile-card__sub-role">MEC Design Expert</p>
              </div>
            </div>

            {/* Accent divider */}
            <div className="profile-card__divider" />

            {/* Biography */}
            <div className="profile-card__body">
              <div className="texty">
                <p>
                  Fred holds a Master’s Degree in Intellectual Property (MIP)
                  from Africa University and a Bachelor of Science Degree in
                  Mechanical Engineering (BSc MEC) from Makerere University.
                </p>
                <p>
                  Fred has developed significant expertise in the realm of
                  change management tools, which empowers him to not only
                  foresee but also proactively navigate changes, especially in
                  the swiftly evolving technical sector. Additionally, he serves
                  as a part-time lecturer in the Department of Electrical and
                  Electronic Engineering at Kyambogo University. In this
                  capacity, he is involved in teaching various course units,
                  including Mechanical Engineering Science, Engineering
                  Mathematics, Mechanical Drawing, Mechanical Workshop Practice,
                  Industrial Management and Organization, Project Planning,
                  Project Design, Instrumentation and Control, and Principles of
                  Maintenance Engineering. Fred also contributes to curriculum
                  enhancements within the department.
                </p>
                <p>
                  Fred's professional journey includes a valuable stint as a
                  Shift Engineer at Kakira Sugar Works Ltd. He is a dynamic and
                  passionate mechanical engineer with a diverse administrative
                  background, marked by robust organizational and communication
                  skills. Fred thrives as a collaborative team player and
                  showcases a penchant for taking personal initiative to achieve
                  project objectives. His adaptability enables him to swiftly
                  acquire new skills and competencies.
                </p>
                <p>
                  Moreover, Fred holds the role of Chief Reconnoiter at the
                  Uganda Business and Technical Examinations Board (UBTEB). In
                  this capacity, he diligently compiles performance data of
                  students across various course units and provides advisory
                  support to the board.
                </p>
                <p>
                  Within the Centre for Integrated Research and Community
                  Development Uganda (CIRCODU), Fred serves as the Field
                  Manager. In this role, he actively participates in field
                  activities that encompass conducting training sessions related
                  to Briquette Making, performing kitchen surveys and tests,
                  delivering training to ENVOCON staff in Tanzania, and
                  contributing to research write-ups.
                </p>
              </div>
            </div>

            {/* Social links */}
            <div className="profile-card__socials">
              <a
                href="https://www.linkedin.com/in/fred-isabirye-b0b59791/"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--linkedin"
                aria-label="LinkedIn"
              >
                <LinkedInIcon />
                <span>LinkedIn</span>
              </a>

              <a
                href="https://twitter.com/CIRCODU1"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--twitter"
                aria-label="X / Twitter"
              >
                <XIcon />
                <span>Twitter / X</span>
              </a>

              <a
                href="https://www.facebook.com/Circodu/"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--facebook"
                aria-label="Facebook"
              >
                <FacebookOutlinedIcon />
                <span>Facebook</span>
              </a>

              <a
                href="https://wa.me/256752876969"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--whatsapp"
                aria-label="WhatsApp"
              >
                <WhatsAppIcon />
                <span>WhatsApp</span>
              </a>

              <a
                href="mailto:fred.isabirye@circodu.org.ug"
                className="profile-card__social-btn profile-card__social-btn--email"
                aria-label="Email"
              >
                <EmailIcon />
                <span>Email</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default FredIsabirye;
